var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5754 20.25H4.42537C4.24082 20.2491 4.0629 20.1811 3.92487 20.0586C3.78685 19.9361 3.69815 19.7675 3.67537 19.5844L2.34412 7.58438C2.33228 7.47982 2.34257 7.37394 2.37433 7.27363C2.40609 7.17331 2.4586 7.0808 2.52845 7.0021C2.5983 6.92341 2.68393 6.8603 2.77977 6.81686C2.87561 6.77343 2.97952 6.75065 3.08474 6.75H20.916C21.0212 6.75065 21.1251 6.77343 21.221 6.81686C21.3168 6.8603 21.4024 6.92341 21.4723 7.0021C21.5421 7.0808 21.5946 7.17331 21.6264 7.27363C21.6582 7.37394 21.6685 7.47982 21.6566 7.58438L20.3254 19.5844C20.3026 19.7675 20.2139 19.9361 20.0759 20.0586C19.9378 20.1811 19.7599 20.2491 19.5754 20.25V20.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.75V6.75C8.25 5.75544 8.64509 4.80161 9.34835 4.09835C10.0516 3.39509 11.0054 3 12 3C12.9946 3 13.9484 3.39509 14.6517 4.09835C15.3549 4.80161 15.75 5.75544 15.75 6.75V9.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.cb332fa85b209939398cecb9ab45e81e.svg";
export { ForwardRef as ReactComponent };